import { render, staticRenderFns } from "./DeniedsListItem.vue?vue&type=template&id=9f56bb7a&"
import script from "./DeniedsListItem.vue?vue&type=script&lang=js&"
export * from "./DeniedsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports